<template>
  <a-drawer
    title="微信变现方式"
    width="700"
    :visible="visible"
    :closable="false"
    @close="onClose"
  >
    <!-- from -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 变现类型 -->
      <a-form-item
        label="变现类型"
        name="wx_type"
        :rules="[{ required: true, message: '请选择变现类型' }]"
      >
        <a-radio-group v-model:value="formState.wx_type">
          <a-radio
            v-for="item in WXProfitTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- 是否存在会员 -->
      <a-form-item
        label="是否存在会员"
        name="wx_vip"
        :rules="[{ required: true, message: '请选择是否存在会员' }]"
      >
        <a-radio-group v-model:value="formState.wx_vip">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="2">否</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <div class="footer-view">
        <span class="footer-hint" v-if="selectKeys.length > 0">
          共选择了{{ selectKeys.length }}部短剧<template v-if="selectKeys.length <= 50"> (最多选择50部)</template>
        </span>
        <div style="flex: 1;"></div>
        <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
        <a-button type="primary" @click="touchSubmit" :disabled="selectKeys.length === 0 || selectKeys.length > 50">确定</a-button>
      </div>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { WXProfitTypes } from '@/utils/constant'
import Loading from '@/components/Loading'
import { setWxType } from '@/api/copyright'

// emit
const emit = defineEmits(['success'])
// from
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 选中的影剧列表
let selectKeys = ref([])
// 表单参数
const formState = reactive({
  // 微信变现类型：1-纯IAA；2-纯IAP；3-IAAP混合变现
  wx_type: undefined,
  // 是否存在会员功能: 1-有；2-无
  wx_vip: undefined
})

// 显示
function showDrawer (keys) {
  // 重置表单
  formState.wx_type = undefined
  formState.wx_vip = undefined
  // 多选时，用到 keys
  selectKeys.value = keys || []
  // 显示
  visible.value = true
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    visible.value = false
    resetFields()
  }
}

// 重置
function resetFields () {
  RefForm.value.resetFields()
}

// 提交
function touchSubmit () {
  // 验证选中数量
  if (selectKeys.value.length === 0) {
    message.warning('请至少选择一部短剧')
    return
  }
  if (selectKeys.value.length > 50) {
    message.warning('最多只能选择50部短剧')
    return
  }
  
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      drama_ids: selectKeys.value,
      wx_type: formState.wx_type,
      wx_vip: formState.wx_vip
    }
    setWxType(params).then(res => {
      isLoading.value = false
      const { code, msg } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.footer-view {
  display: flex;
  align-items: center;
}
.footer-hint {
  color: #5A5A5A;
}
</style>
